import {FC} from 'react'

import {theme} from '@/theme/theme'

import {ButtonVariant} from '../content/ButtonTypes'
import {IconButton} from '../content/IconButton'
import {ArrowIcon} from '../icons/ArrowIcon'

type OfficeLocationButtonProps = {
  variant?: 'right' | 'left'
  ariaLabel: string
  onClick: () => void
}

export const OfficeLocationButton: FC<React.PropsWithChildren<OfficeLocationButtonProps>> = ({
  variant = 'right',
  ariaLabel,
  onClick,
}) => {
  return (
    <IconButton
      variant={ButtonVariant.tertiary}
      isOutlined
      icon={<ArrowIcon variant={variant} color={theme.palette.text.default} />}
      onClick={onClick}
      ariaLabel={ariaLabel}
    />
  )
}
